import { useEffect } from 'react'

import { useNavigate, useParams } from 'react-router-dom'

import { BreadcrumbsComponent } from '../../components/Breadcrumbs'
import { DealComponent } from '../../components/Deal'
import { LayoutPage } from '../../components/LayoutPage'
import { SpinnerComponent } from '../../components/Spinner'

import { useAppContext } from '../../hooks/useAppContext'
import { useSimpleState } from '../../hooks/useSimpleState'
import { useView } from '../../hooks/useView'

import { FetchHelper } from '../../helpers/fetch'

import './index.css'

const DealDetailPage = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const {ac} = useAppContext()

    const {_state} = useSimpleState({
        deal: null,
        notFound: false,
    })

    const {_view} = useView({
        initialView: 'loading',
        views: {
            loading: renderLoading,
            main: renderMain,
        }
    })

    const fetchDeal = () => {
        return FetchHelper({
            url: `/api/v1/deals/${id}`
        })
            .then((res) => {
                if (res.status === 200) {
                    _state.set('deal', res.body)
                } else {
                    _state.set('notFound', true)
                }
            })
            .catch(() => {
                _state.set('notFound', true)
            })
            .finally(() => {
                _view.set('main')
            })
    }

    const handleDealClick = (item) => {
        FetchHelper({
            url: '/api/v1/deals/click',
            options: { method: 'put', data: { id: item.id } }
        })

        setTimeout(() => {
            window.open(item.url, '_blank')
        }, 500)
    }

    const handleDealClickDead = (item) => {
        FetchHelper({
            url: '/api/v1/deals/click_dead',
            options: { method: 'put', data: { id: item.id } }
        })
    }

    const handleBack = () => {
        navigate('/')
    }

    useEffect(() => {
        fetchDeal()
    }, [id])

    function renderLoading() {
        return (
            <div className="dealDetail-content">
                <SpinnerComponent />
            </div>
        )
    }

    function renderMain() {
        if (_state.get('notFound')) {
            return (
                <div className="dealDetail-notFound">
                    <h2>Deal Not Found</h2>
                    <p>This deal may have expired or been removed.</p>
                </div>
            )
        }

        return (
            <div className="dealDetail-content">
                <button className="dealDetail-back" onClick={handleBack} aria-label="Back to deals">
                    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.5">
                        <line x1="19" y1="12" x2="5" y2="12" />
                        <polyline points="12 19 5 12 12 5" />
                    </svg>
                </button>

                <DealComponent value={_state.get('deal')} events={{
                    handleClick: handleDealClick,
                    handleClickDead: handleDealClickDead
                }} />
            </div>
        )
    }

    return (
        <LayoutPage config={{ id: 'DealDetail' }}>
            <div className="c-DealDetail">
                <BreadcrumbsComponent value={[
                    { label: 'Home', to: '/' },
                    { label: _state.get('deal')?.name || 'Deal' },
                ]} />

                {_view.get()}
            </div>
        </LayoutPage>
    )
}

export { DealDetailPage }
